// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__h3Dod","textContainer":"ErrorPage_textContainer__P-Nxc","title":"ErrorPage_title__ESEts","subtitle":"ErrorPage_subtitle__lFJeQ"};